// extracted by mini-css-extract-plugin
export default {"card":"partner-card_card__QTMND","logo":"partner-card_logo__pRezf","logoWrapper":"partner-card_logoWrapper__9Ms7v"};